<template>
  <div style="margin-top: 120px;">
    <search-nav :active="5"></search-nav>
    <!-- <el-affix :offset="120"> -->
      <el-row>
        <div class="container">
          <!--输入框-->
          <el-row style="margin-bottom: 30px">
            <el-col :span="13">
              <div>
                <el-autocomplete
                  style="width: 100%"
                  clearable
                  class="inline-input"
                  v-model="conditions.keyword"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入企业名称关键词"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  size="medium"
                  input-style="border-bottom-right-radius:0px;border-top-right-radius:0px;height:50px"
                >
                </el-autocomplete>
              </div>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" style="background: #FC7A1E;border-color: #FC7A1E;" class="search-btn-search" @click="handleSearchList" size="medium">查询</el-button>
            </el-col>
          </el-row>
        </div>
      </el-row>
    <!-- </el-affix> -->
    <el-row>
      <div class="container">
        <!--筛选条件-->
        <div style="margin-bottom: 30px" class="condition-content">
          <div class="dis-bet-cen condition-title">
            <span class="screening-conditions-title" style="font-size: 16px;color: #666666;">筛选条件</span>
            <link-to-advanced></link-to-advanced>
          </div>
          <el-row v-if="tags.length > 0" class="dis-cen-cen already-choose" >
            <el-col :span="2"><div class="grid-content bg-purple" style="font-size: 14px;color: #5D6FE9;">已选条件：</div></el-col>
            <el-col :span="20">
              <div class="grid-content bg-purple dis-sta-cen">
                <el-tag style="margin-right: 10px" v-for="(tag, index) in tags" :key="tag.name" closable :type="tag.type" @close="closeTag(tag, index)">
                  {{tag.name}}
                </el-tag>
              </div>
            </el-col>
            <el-col :span="2">
              <div @click="closeAllTag" class="grid-content bg-purple font-choose-text">清除全部</div>
            </el-col>
          </el-row>
          <el-row v-if="!conditions.personnelKeyword" class="dis-cen-cen already-choose" style="margin-top: 20px;">
            <el-col :span="2"><div class="grid-content bg-purple" style="font-size: 14px;color: #999999;">人员名称：</div></el-col>
            <el-col :span="22">
              <el-row class="dis-sta-cen" style="align-items: center;">
                <el-col :span="13" >
                  <div>
                    <el-input v-model="personnelKeyword" placeholder="请输入人员名称关键词" size="medium" clearable></el-input>
                  </div>
                </el-col>
                <el-col :span="4" style="float: left; margin: 0px 0px 0px 10px;">
                  <el-button style="float: left"  size="medium" @click="personnelKeywordClick">确定</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row v-if="!conditions.relevancyIdArr || conditions.relevancyIdArr.length === 0" class="dis-cen-cen already-choose" style="margin-top: 10px;">
            <el-col :span="2"><div class="grid-content bg-purple" style="font-size: 14px;color: #999999;">人员分类：</div></el-col>
            <el-col :span="22">
              <el-row>
                <el-col :span="13" >
                  <div v-if="clearForm">
                    <el-cascader
                      ref="cascader"
                      clearable
                      collapse-tags
                      separator=">"
                      filterable="true"
                      placeholder="请选择人员分类"
                      style="width: 100%;"
                      v-model="cascaderValue"
                      size="medium"
                      :options="cascaderOptions"
                      :props="cascaderProps"
                      @change="cascaderHandleChange"></el-cascader>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="dis-cen-cen already-choose" style="margin-top: 15px;margin-bottom: 15px;">
            <el-col :span="2">
              <div class="grid-content bg-purple" >
                <el-button type="primary" size="medium" @click="queryList()">查询</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--内容卡片 柏成大佬-->
        <el-row style="margin-top: 30px;margin-bottom: 30px">
          <el-col :span="24">
            <div class="condition-content">
              <div class="dis-bet-cen condition-title">
                <span class="screening-conditions-title">共查询到
                  <span v-if="page.total < 0" class="font-color-red">0</span>
                  <span v-else class="font-color-red">{{ page.total }}</span>
                  条符合条件的人员</span>
                <span class="advanced-query-title">
              </span>
              </div>
              <div class="condition-content-list">
                <block v-show="!fuzzyDataShow" v-for="(item, index) of dataListComputed" :key="index">
                  <el-row class="list-padding dis-cen-cen">
                    <el-col :span="24">
                      <div class="condition-content-list-name dis-bet-cen">
                        <div class="dis-sta-cen">
                          <span style="cursor: pointer;" @click="companyNameClick(item)" v-html="item.companyName + '-' + item.name"></span>
                          <span class="focus-enterprises-tag-yellow">{{item.qualificationName}}</span>
                        </div>
                        <el-popover placement="left" :width="400" trigger="click" v-if="item.companyRegisteredPersonnelList.length > 1">
                          <template #reference>
                            <span style="font-size: 14px;color: #666;font-weight: 400;cursor: default;">关联证书
                            <span class="font-color-zs">{{item.companyRegisteredPersonnelList.length}}</span><i class="el-icon-arrow-right"></i></span>
                          </template>
                          <el-table :header-cell-style="headerColor" :data="item.companyRegisteredPersonnelList" style="width: 100%">
                             <el-table-column  property="qualificationName" label="证书类别"></el-table-column>
                             <el-table-column  property="certificateNo" label="证书编号">
                               <template #default="scope">
                                 <span >{{scope.row.certificateNo ? scope.row.certificateNo : '-'}}</span>
                               </template>
                             </el-table-column>
                             <el-table-column  label="截止日期">
                                <template #default="scope">
                                  <span >{{scope.row.validPeriod ? (scope.row.validPeriod).substring(0, 10): '-'}}</span>
                                </template>
                             </el-table-column>
                           </el-table>
                        </el-popover>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <el-row class="condition-content-list-title">
                        <el-col :span="2">参建项目：</el-col>
                        <el-col :span="20" style="margin-left: -15px;">
                          <el-row :gutter="20" class="dis-sta-cen" style="margin-bottom: 10px;" v-for="(items, indexs) of item.companyAchievementList" :key="indexs">
                            <el-col :span="16">
                              <span class="font-color-gray" style="cursor: pointer;" @click="companyAchievementNameClick(items)">{{items.projectName || '-'}}</span>
                            </el-col>
                            <el-col :span="6">中标时间：<span class="font-color-gray">{{(items.timeSuccess).substring(0, 10) || '-'}}</span></el-col>
                          </el-row>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-divider v-if="(index + 1) != dataList.length"></el-divider>
                </block>
                <el-empty v-if="dataList.length === 0"  :image-size="200"></el-empty>
                <gaussian-blur pageName="company-achievement" v-show="fuzzyDataShow"></gaussian-blur>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--分页组件-->
        <div class="dis-end-sta" style="margin-bottom: 30px">
          <el-pagination
            :hide-on-single-page="true"
            :pager-count="page.pagerCount"
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            v-model:currentPage="page.pageNum"
            :total="page.total">
          </el-pagination>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import SearchNav from '@/components/search-nav/search-nav'
import LinkToAdvanced from '@/components/link-to-advanced/link-to-advanced'
// import { forwardBG } from '@/api/forward.js'
import { getAllArtisanRelevancy } from '@/api/query.js'
import { forwardBG, oldForwardBG } from '@/api/forward.js'
import { mapGetters } from 'vuex'
import GaussianBlur from '@/components/gaussian-blur/gaussian-blur'
import { peopleName, getcompanyName } from '@/utils/toDate'
export default {
  name: 'company-personnel-perfo',
  components: {
    SearchNav,
    LinkToAdvanced,
    GaussianBlur
  },
  setup (props, context) {
    function loginEmit () {
      context.emit('loginEmit', 'topNav')
    }
    return {
      loginEmit
    }
  },
  data () {
    return {
      personnelKeyword: '', // 人员名称关键字
      conditions: {
        keyword: this.$route.query.searchVal ? this.$route.query.searchVal : '', // 查询的关键字
        personnelKeyword: '', // 已经选择的人员名称
        relevancyIdArr: [] // 人员分类多级数组
      },
      queryConditions: {
        keyword: '', // 查询的关键字
        personnelKeyword: '', // 已经选择的人员名称
        relevancyIdArr: [] // 人员分类多级数组
      },
      clearForm: true,
      cascaderValue: [],
      cascaderOptions: [], // 需要的格式参考饿了么UI 的级联选择器
      cascaderProps: { multiple: false, expandTrigger: 'hover' },
      // 数据
      dataList: [], // 查询回来的数据
      tags: [],
      page: { // 分页使用
        total: -1, // 总条数
        pagerCount: 7,
        pageNum: 1
      },
      // 分页查询使用 一次返回几百条使用
      pageNum: 1,
      pageSize: 300,
      noData: false, // 已经没有更多数据了
      returnLimit: false, // 返回数据是否受限
      fuzzyDataShow: false, // 模糊图片是否显示
      fuzzyData: require('@/assets/images/fuzzy_data.png')
    }
  },
  computed: {
    ...mapGetters([
      'vipData', // 会员数据
      'idToken'
    ]),
    vipLevelChange: function () {
      const vm = this
      // console.log('计算属性: ' + JSON.parse(vm.vipData).vipLevel)
      if (vm.vipData && JSON.parse(vm.vipData)) {
        return JSON.parse(vm.vipData).vipLevel
      } else {
        return null
      }
    },
    dataListComputed: function () {
      const vm = this
      const arr = []
      for (let i = 0; i < vm.dataList.length; i++) {
        if (i >= (vm.page.pageNum - 1) * 10 && i < vm.page.pageNum * 10) {
          arr.push(vm.dataList[i])
        }
      }
      return arr
    }
  },
  watch: {
    vipLevelChange: function (newValue, oldValue) {
      this.returnLimit = false
      this.dataList = []
      this.initGetAllArtisanRelevancy()
      this.handleSearchList()
    }
  },
  mounted () {
    // const vm = this
    this.initGetAllArtisanRelevancy()
    this.handleSearchList()
  },
  methods: {
    // 表格设置样式
    headerColor: function ({ row, column, rowIndex, columnIndex }) {
      return 'background-color:#E8EBFC;color:#666666;font-size:14px;text-align:center'
    },
    // 输入框输入内容触发
    querySearch (queryString, callback) {
      const arr = []
      callback(arr)
    },
    // 输入框选择之后返回的数据
    handleSelect (item) {
      this.conditions.keyword = item.value
    },
    // 获取所有人员分类
    initGetAllArtisanRelevancy () {
      const vm = this
      getAllArtisanRelevancy().then(result => {
        console.log(result)
        if (result.code === 0) {
          const res = result.data
          vm.totalCascaderList = res
          vm.getRelevancyList(res, '0', function (a) {
            console.log(a)
            vm.cascaderOptions = a
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    // 人员名称的确定按钮
    personnelKeywordClick () {
      const vm = this
      if (vm.personnelKeyword) {
        vm.conditions.personnelKeyword = vm.personnelKeyword
        vm.personnelKeyword = ''
        vm.tags.push({
          name: '人员名称：' + vm.conditions.personnelKeyword,
          value: 'personnelKeyword',
          default: ''
        })
      } else {
        return ElMessage.warning({
          message: '请先输入人员名称关键字',
          type: 'warning',
          offset: 60
        })
      }
    },
    getRelevancyList: function (data, parentId, callback) {
      const arr = []
      const vm = this
      data.forEach((item, index) => {
        let obj = {}
        if (item.parentId === parentId && item.name !== '其他人员' && item.name !== '安全评价师' && item.name !== '三类人员' && item.name !== '现场管理人员' && item.name !== '系统集成项目经理' && item.name !== '信息技术服务标准（ITSS）人员') {
          obj = {
            value: item.id,
            label: item.name,
            parentId: item.parentId
          }
          if (vm.getRelevancyListChild(data, item, item.id).length > 0) {
            obj.children = vm.getRelevancyListChild(data, item, item.id)
          }
          arr.push(obj)
        }
      })
      callback(arr)
    },
    getRelevancyListChild: function (arr, parentItem, parentId) {
      const vm = this
      const arrs = []
      arr.forEach((item, index) => {
        let obj = {}
        if (item.parentId === parentId) {
          if (vm.getRelevancyListChild(arr, item, item.id).length > 0) {
            obj = {
              value: item.id,
              label: item.name,
              parentId: item.parentId,
              children: vm.getRelevancyListChild(arr, item, item.id)
            }
          } else {
            obj = {
              value: item.id,
              label: item.name,
              parentId: item.parentId
            }
          }
          arrs.push(obj)
        }
      })
      return arrs
    },
    // 多级下拉的回调
    cascaderHandleChange (item) {
      const vm = this
      console.log(item)
      const n = item.length - 1
      vm.conditions.relevancyIdArr.push(item[n])
      const relevancyNameArr = vm.treeToLabel(vm.cascaderOptions, item)
      // 清理选中项
      vm.cascaderValue = []
      vm.tags.push({
        name: '人员分类：' + relevancyNameArr,
        value: 'relevancyIdArr',
        default: []
      })
    },
    // 关闭Tag触发
    closeTag (item, index) {
      const vm = this
      vm.tags.splice(index, 1)
      vm.conditions[item.value] = item.default
    },
    // 清除全部Tag
    closeAllTag () {
      const vm = this
      vm.tags = []
      vm.conditions.personnelKeyword = ''
      vm.conditions.relevancyIdArr = []
    },
    // 翻页时触发
    currentChange (cuttentPage) {
      const vm = this
      if (vm.idToken) {
        if (vm.returnLimit) { // 已经返回受限了 就不继续查询了
          vm.page.pageNum = -Math.ceil(Math.random() * 1000)
          vm.fuzzyDataShow = true
        } else {
          document.documentElement.scrollTop = 0
          vm.page.pageNum = cuttentPage
          // 数据不够了 并且没超过一千并且 后面还有数据就去查询
          if (vm.page.pageNum * 10 > vm.dataList.length - 10 && vm.dataList.length < 1000 && !vm.noData) {
            vm.pageNum = vm.pageNum + 1
            vm.getList()
          }
        }
      } else {
        vm.page.pageNum = -Math.ceil(Math.random() * 1000)
        vm.loginEmit()
      }
    },
    treeToLabel (data, arr) {
      const result = []
      const childrenTreeToLabel = (data, arr, result) => {
        for (let j = 0; j < data.length; j++) {
          if (arr[0] === data[j].value) {
            result.push(data[j].label)
            if (data[j].children && arr.length > 1) {
              childrenTreeToLabel(data[j].children, arr.slice(1), result)
            }
            break
          }
        }
      }
      childrenTreeToLabel(data, arr, result)
      return result.join('>')
    },
    // 点击查询触发
    handleSearchList: function () {
      const vm = this
      vm.pageNum = 1
      vm.page.total = -1
      // 如果跟上次查询的不一样就清理下面
      if (vm.oldKeyword !== vm.conditions.keyword) {
        vm.closeAllTag()
        vm.queryConditions.personnelKeyword = ''
        vm.queryConditions.relevancyIdArr = []
      }
      vm.oldKeyword = vm.conditions.keyword
      vm.queryConditions.keyword = vm.conditions.keyword
      vm.page.pageNum = 1
      // 去查询
      vm.dataList = []
      vm.getList()
    },
    queryList: function () {
      const vm = this
      vm.pageNum = 1
      vm.page.total = -1
      if (vm.idToken) {
        if (vm.returnLimit) { // 已经返回受限了 就不继续查询了
          vm.page.pageNum = -Math.ceil(Math.random() * 1000)
          vm.fuzzyDataShow = true
        } else {
          vm.page.pageNum = 1
          vm.queryConditions.relevancyIdArr = vm.conditions.relevancyIdArr
          vm.queryConditions.personnelKeyword = vm.conditions.personnelKeyword
          vm.getList()
        }
      } else {
        vm.loginEmit()
      }
    },
    getList: function () {
      const vm = this
      vm.dataList = []
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = {
        dateBackgroundUrl: vm.idToken ? '/companyPersonnelResults/getCompanyPersonnelResultsSpecial' : '/esFake/companyPersonnelResults/getCompanyPersonnelResultsSpecial',
        dateBackgroundRequestType: 'GET',
        data: {
          relevancyId: vm.queryConditions.relevancyIdArr ? vm.queryConditions.relevancyIdArr[0] : null,
          name: vm.queryConditions.personnelKeyword ? vm.queryConditions.personnelKeyword.trim() : null,
          companyName: vm.queryConditions.keyword ? vm.queryConditions.keyword.trim() : null,
          pageNum: vm.pageNum,
          pageSize: vm.pageSize
        }
      }
      const forward = vm.idToken ? oldForwardBG : forwardBG
      forward(data).then(result => {
        if (result.code === 0 || result.code === 97 || result.code === 98) {
          if (result.code === 97) {
            vm.returnLimit = true
            vm.fuzzyDataShow = false
          } else if (result.code === 98) {
            vm.returnLimit = true
            vm.fuzzyDataShow = true
          } else {
            vm.returnLimit = false
            vm.fuzzyDataShow = false
          }
          const res = result.data
          const arr = []
          if (res.length > 0) {
            res.forEach((item, index) => {
              const thisCompanyAchievementList = item.companyAchievementList ? item.companyAchievementList : []
              if (vm.returnLimit || !vm.idToken) {
                for (let i = 0; i < thisCompanyAchievementList.length; i++) {
                  thisCompanyAchievementList[i].projectName = getcompanyName(thisCompanyAchievementList[i].projectName)
                }
              }
              const obj = {
                companyId: item.companyId,
                companyName: item.companyName,
                companyAchievementList: thisCompanyAchievementList,
                companyRegisteredPersonnelList: item.companyRegisteredPersonnelList ? item.companyRegisteredPersonnelList : [],
                name: item.name === null || item.name === 'null' ? '-' : (vm.returnLimit || !vm.idToken ? peopleName(item.name) : item.name),
                qualificationName: item.qualificationName === null || item.qualificationName === 'null' ? '-' : item.qualificationName
              }
              arr.push(obj)
            })
            loading.close()
          } else {
            loading.close()
            vm.noData = true
          }
          if (vm.page.total === -1) {
            if (res.length > 0) {
              vm.page.total = res[0].dataTotal
            } else {
              vm.page.total = 0
            }
          }
          vm.dataList = vm.dataList.concat(arr)
        }
        loading.close()
      }).catch(error => {
        console.log(error)
        loading.close()
      })
    },
    // 点击了 公司名 跳转到公司详情
    companyAchievementNameClick (item, index) {
      const vm = this
      sessionStorage.removeItem('company-achievement-details-item')
      sessionStorage.setItem('company-achievement-details-item', JSON.stringify(item))
      const routeData = vm.$router.resolve({
        name: 'company-achievement-details'
      })
      window.open(routeData.href, '_blank')
    },
    // 点击了 公司名 跳转到公司详情
    companyNameClick (item, index) {
      const vm = this
      vm.$store.dispatch('setBusId', item.companyId)
      vm.$router.push({ name: 'enterprise-details' })
    }
  }
}
</script>

<style scoped="scoped">
.already-choose{
  margin-bottom: 10px;
  margin-top: 10px
}
.input-search {
  margin-top: 120px;
}
/deep/ .el-input-group__append, .el-input-group__prepend {
  background-color: #5D6FE9;
  border: none;
  color: #fff;
  width: 70px;
}
.conditions-font-title {
  font-size: 14px;
  color: #999;
  display: block;
  height: 40px;
  line-height: 40px;
}
.focus-enterprises-tag {
  position: absolute;
  top: 50%;
  right: 20px;
  height: 30px;
  margin-top: -17px;
  border: 1px solid #5D6FE9;
  color: #5D6FE9;
  line-height: 30px;
  padding: 0 5px;
  font-size: 14px;
  cursor: pointer;
}
.focus-enterprises-tag-gray {
  position: absolute;
  top: 50%;
  right: 20px;
  height: 30px;
  margin-top: -17px;
  border: 1px solid #E6E6E6;
  color: #666;
  line-height: 30px;
  padding: 0 5px;
  font-size: 14px;
  cursor: pointer;
}
.focus-enterprises-tag-yellow {
  color: #EA9920;
  padding: 0 5px;
  border: 1px solid #EA9920;
  cursor: pointer;
  font-size: 12px;
  margin-left: 10px;
}
.list-hover:hover{
  background-color: #F3F9FD;
}
.el-divider--horizontal {
  margin: 0;
}
/deep/ .el-input.el-input--medium.el-input--suffix {
  line-height: 50px !important;
}
</style>
